import { render, staticRenderFns } from "./PublicationDataCollectionModal.vue?vue&type=template&id=f4fe563a&"
import script from "./PublicationDataCollectionModal.vue?vue&type=script&lang=js&"
export * from "./PublicationDataCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports